<div class="drag-grip"></div>

@if (hidden()) {
  <div class="hidden-indicator"></div>
}
@if (extension() && useListIcon()) {
  <span class="item-list-icon" matListItemIcon>
    <mat-icon [svgIcon]="type() | fileTypeIcon: true : extension()"></mat-icon>
    <span>{{ extension() }}</span>
  </span>
}
<div class="mdc-list-item__content">
  @if (hidden() && hiddenLabel()) {
    <mulo-status-tag [description]="hiddenDescription()">{{ hiddenLabel() }}</mulo-status-tag>
  }
  <ng-content select="[matListItemTitle]"></ng-content>
  <ng-content select="[mat-line], [matLine], [matListItemLine]"></ng-content>

  <div class="list-item-wrap">
    <div class="list-item-header">
      <!-- list number -->
      @if (index()) {
        <span class="item-index">{{ index() }}. </span>
      }
      <span class="item-name">
        <!-- files -->
        <ng-content select="[slot='file-info']"></ng-content>
        @if (!fileInfoTemplate()) {
          @if (baseName() ?? name(); as itemName) {
            <span class="item-basename semibold">
              @if (url()) {
                <a [href]="url()" [target]="urlTarget()" [matTooltip]="itemName">{{ itemName }}</a>
              } @else {
                <span [matTooltip]="itemName">{{ itemName }}</span>
              }
            </span>
          }
          @if (extension() && !useListIcon()) {
            <span class="item-ext item-header-field">
              <mat-icon [svgIcon]="type() | fileTypeIcon: true : extension()"></mat-icon>
              <span>{{ extension() }}</span>
            </span>
          }
          @if (date()) {
            <span class="item-header-field">{{ date() }}</span>
          }
          @if (size()) {
            <span class="item-size item-header-field">{{ size() | fileSize }}</span>
          }
        }
      </span>

      <span class="item-actions">
        <ng-content select="[mulo-file-action]"></ng-content>

        <ng-container *mediaIf="'gt-sm'">
          @for (action of visibleActions(); track $index) {
            @switch (action?.type) {
              @case ('toggle') {
                <mat-slide-toggle
                  [checked]="action.data.checked"
                  (change)="handleActionEvent(action, $event)"
                  color="primary"
                  [disabled]="action.disabled"
                  class="is-slim is-quiet has-label-below"
                >
                  @if (action.data.checked) {
                    {{ (action.labels[0] | translate) || action.labels[0] }}
                  } @else {
                    {{ (action.labels[1] | translate) || action.labels[1] }}
                  }
                </mat-slide-toggle>
              }
              @case ('visibility') {
                <mulo-visibility-switch
                  [active]="action.data.visible"
                  (changed)="handleActionEvent(action, $event)"
                  [visibleLabel]="action.labels[0]"
                  [hiddenLabel]="action.labels[1]"
                  [toolTipText]="action.labels[2]"
                  [disabled]="action.disabled"
                >
                </mulo-visibility-switch>
              }
              @case ('icon-btn') {
                <button
                  mat-icon-button
                  (click)="handleActionEvent(action, $event)"
                  (muloMultipleEvents)="handleActionEvent(action, $event)"
                  [attr.aria-label]="action.labels[1] || action.labels[0]"
                  [disabled]="action.disabled"
                  type="button"
                >
                  <mat-icon [class.mat-icon-rtl-mirror]="action.rtlMirrorIcon" [svgIcon]="action.icon"></mat-icon>
                </button>
              }
              @case ('button') {
                <button
                  mat-button
                  (click)="handleActionEvent(action, $event)"
                  (muloMultipleEvents)="handleActionEvent(action, $event)"
                  [disabled]="action.disabled"
                  color="primary"
                  type="button"
                >
                  @if (action.icon) {
                    <mat-icon [class.mat-icon-rtl-mirror]="action.rtlMirrorIcon" [svgIcon]="action.icon"></mat-icon>
                  }
                  <span>{{ (action.labels[0] | translate) || action.labels[0] }}</span>
                </button>
              }
            }
          }
          @if (removable()) {
            <button
              mat-icon-button
              (click)="onRemove($event, index())"
              (muloMultipleEvents)="onRemove($event, index())"
              [attr.aria-label]="fileRemoveTip()"
              type="button"
            >
              <mat-icon svgIcon="close"></mat-icon>
            </button>
          }
        </ng-container>
        @if (progress()) {
          <span class="progress-count">
            @if (progress() < 100) {
              <mat-icon svgIcon="upload-arrow"></mat-icon>
              <span class="semibold">{{ progress() / 100 | percent }}</span>
            } @else {
              <mat-icon svgIcon="check" [matTooltip]="doneUploadMsg()" class="color-positive"></mat-icon>
            }
          </span>
          @if (progress() >= 100) {
            <a mat-icon-button [href]="'#'" [matTooltip]="filePreviewTip()" target="_blank">
              <mat-icon svgIcon="eye-outline"></mat-icon>
            </a>
          }
        }
      </span>
      @if (progress() && progress() < 100) {
        <mat-progress-bar mode="determinate" [value]="progress()"> </mat-progress-bar>
      }
    </div>
    <div class="list-item-content" #content>
      <!-- content that appears in the opened drawer -->
      <ng-content></ng-content>
    </div>
  </div>
</div>

<ng-container *mediaIf="'lt-md'">
  @if (actions().length > 0 || removable()) {
    <button mat-icon-button [matMenuTriggerFor]="actionsMenu" [attr.aria-label]="moreBtnLabel()">
      <mat-icon svgIcon="dots-vertical"></mat-icon>
    </button>
  }
  <mat-menu #actionsMenu="matMenu" xPosition="before">
    <ng-template matMenuContent>
      @for (action of menuActions(); track $index) {
        @switch (action?.type) {
          @case ('toggle') {
            <button mat-menu-item (click)="$event?.stopPropagation()" [disabled]="action.disabled" type="button">
              @if (action.icon) {
                <mat-icon [class.mat-icon-rtl-mirror]="action.rtlMirrorIcon" [svgIcon]="action.icon"></mat-icon>
              }
              <mat-slide-toggle
                [checked]="action.data.checked"
                (change)="handleActionEvent(action, $event)"
                color="primary"
                labelPosition="before"
                [disabled]="action.disabled"
              >
                @if (action.data.checked) {
                  {{ (action.labels[0] | translate) || action.labels[0] }}
                } @else {
                  {{ (action.labels[1] | translate) || action.labels[1] }}
                }
              </mat-slide-toggle>
            </button>
          }
          @case ('visibility') {
            <button mat-menu-item (click)="$event?.stopPropagation()" [disabled]="action.disabled" type="button">
              @if (action.icon) {
                <mat-icon [class.mat-icon-rtl-mirror]="action.rtlMirrorIcon" [svgIcon]="action.icon"></mat-icon>
              }
              <mat-slide-toggle
                [checked]="action.data.visible"
                (change)="handleActionEvent(action, $event)"
                color="primary"
                labelPosition="before"
                [disabled]="action.disabled"
              >
                @if (action.data.visible) {
                  {{ (action.labels[0] | translate) || action.labels[0] }}
                } @else {
                  {{ (action.labels[1] | translate) || action.labels[1] }}
                }
              </mat-slide-toggle>
            </button>
          }
          @case ('icon-btn') {
            <button
              mat-menu-item
              (click)="handleActionEvent(action, $event)"
              (muloMultipleEvents)="handleActionEvent(action, $event)"
              [disabled]="action.disabled"
              type="button"
            >
              @if (action.icon) {
                <mat-icon [class.mat-icon-rtl-mirror]="action.rtlMirrorIcon" [svgIcon]="action.icon"></mat-icon>
              }
              <span>{{ (action.labels[0] | translate) || action.labels[0] }}</span>
            </button>
          }
          @case ('button') {
            <button
              mat-menu-item
              (click)="handleActionEvent(action, $event)"
              (muloMultipleEvents)="handleActionEvent(action, $event)"
              [disabled]="action.disabled"
              type="button"
            >
              @if (action.icon) {
                <mat-icon [class.mat-icon-rtl-mirror]="action.rtlMirrorIcon" [svgIcon]="action.icon"></mat-icon>
              }
              <span>{{ (action.labels[0] | translate) || action.labels[0] }}</span>
            </button>
          }
        }
      }
      <button
        mat-menu-item
        (click)="onRemove($event, index())"
        (muloMultipleEvents)="onRemove($event, index())"
        type="button"
      >
        <span>{{ (fileRemoveTip() | translate) || fileRemoveTip() }}</span>
      </button>
    </ng-template>
  </mat-menu>
</ng-container>
<ng-content select="[matListItemMeta]"></ng-content>

<ng-content select="mat-divider"></ng-content>

<!--
  Strong focus indicator element. MDC uses the `::before` pseudo element for the default
  focus/hover/selected state, so we need a separate element.
-->
<div class="mat-mdc-focus-indicator"></div>
